<ng-container *ngIf="!user">
  <app-spinner></app-spinner>
</ng-container>
<ng-container *ngIf="user">
  <tyt-tabs #tabs>
    <tyt-tab id="in_app" label="On TYT.com">
      <h2>Notifications on This Website</h2>
      <p>Adjusting these toggles will control what notifications appear in the notification center in the top right. You can access them by clicking on your profile photo.</p>
    </tyt-tab>

    <tyt-tab id="email" label="Email">
      <h2>Notifications Delivered to Your Email</h2>
      <p>Configure your TYT daily email digest. Choose which parts of TYT content you’d like to see, and we will combine and deliver straight to your inbox.</p>
      <p>You will receive your chosen newsletters at the address associated with your TYT account, which is <em>{{ user.email }}</em></p>
    </tyt-tab>
  </tyt-tabs>

  <ng-container *ngFor="let pref of this.prefs; let i = index">
    <section *ngIf="pref.provider === tabs.selectedTab">
      <mat-slide-toggle labelPosition="before" [(ngModel)]="prefValues[i]">
        {{ pref.label }}
      </mat-slide-toggle>
    </section>
  </ng-container>

  <div class="buttons" (click)="saveChanges()">
    <button type="button" mat-stroked-button color="primary">Save Changes</button>
  </div>
</ng-container>
